export const toolbarOptions = [
  ['bold', 'italic', 'underline', {header: 1}, {header: 2}, {list: 'bullet'}],
  // ['link'],
  // ['clean'],
  // ['image'],
];

export const defaultPlaceholderTextId = 'richTextEditor.placeholder';
